import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'MyTypes';

import { DataCollectionResource, ResourceList } from '@portal/common/types';

import { COVID_19_EXPLORER_PATH, DENGUE_SCENARIOS_PATH } from '../../router/paths';
import { getRouter } from '../router/selectors';
import {
    getIsImpersonatedSession,
    getIsNotFreshUser,
    getIsStealthUser,
} from '../session/selectors';
import { getActiveSurvey } from '../surveys/selectors';

export const getDismissedWelcomeMessageHash = (state: RootState) =>
    state.userSettings.dismissedWelcomeMessageHash;

export const getSelectedDataTool = createSelector(getRouter, ({ pathname }) => pathname);

export const checkIsCovid19DataTool = createSelector(
    getSelectedDataTool,
    (selectedDataTool) => selectedDataTool === COVID_19_EXPLORER_PATH
);

export const checkIsDengueDataTool = createSelector(
    getSelectedDataTool,
    (selectedDataTool) => selectedDataTool === DENGUE_SCENARIOS_PATH
);

export const getDashboardTabs = (state: RootState): ResourceList[] =>
    state.userSettings.dashboardTabs;

export const getSelectedDataCollectionIdByDataTools = (
    state: RootState
): null | Record<string, number> => state.userSettings.selectedDataCollectionIdByDataTool;

export const getSelectedDataCollectionForDataTool = createSelector(
    (state) => state.dataExplorer.dataCollections,
    getSelectedDataCollectionIdByDataTools,
    getSelectedDataTool,
    (dataCollections, selectedDataCollectionIdByDataTool, dataTool) => {
        let dataCollection: DataCollectionResource | undefined;
        if (
            dataCollections &&
            selectedDataCollectionIdByDataTool &&
            dataTool &&
            selectedDataCollectionIdByDataTool[dataTool]
        ) {
            const dataCollectionId = selectedDataCollectionIdByDataTool[dataTool];
            dataCollection = dataCollections.find(({ id }) => id === dataCollectionId);
        }

        return dataCollection;
    }
);

export const getIsSidebarMinimized = (state: RootState): boolean =>
    state.userSettings.isSidebarMinimized;

export const getIsQueryBuilderCollapsed = (state: RootState): boolean =>
    state.userSettings.isQueryBuilderCollapsed;

export const getIsSurveyPostponed = (state: RootState): boolean =>
    state.userSettings.isSurveyPostponed;

export const getIsSurveyAccessible = createSelector(
    getActiveSurvey,
    getIsStealthUser,
    getIsImpersonatedSession,
    getIsNotFreshUser,
    (activeSurvey, isStealthUser, isImpersonatedSession, isNotFreshUser) =>
        !!activeSurvey && !isStealthUser && !isImpersonatedSession && isNotFreshUser
);

export const checkIsSurveyBannerVisible = createSelector(
    getIsSurveyAccessible,
    getIsSurveyPostponed,
    (isSurveyAccessible, isSurveyPostponed) => isSurveyAccessible && isSurveyPostponed
);
